<ng-container *ngIf="product">
  <div class="price">
    {{ product | productPrice: price }}
  </div>
</ng-container>
